import React, { useState, useEffect } from 'react';
import useStyles from './styles';
import { get, last } from 'global/lib/lodash';
import { getId } from './utils';
import { SystemScore } from './SystemScore';

export const ActiveEdit = (props) => {
  const { activeEdit, assessment, setSidebarOpen, setActiveEdit, updateScores, setCurrentAnchor, treed, selectedItems, filter, scorecard, isCourse } = props;
  const [dir, setDir] = useState();
  const [childProps, setChildProps] = useState({
    isCourse,
    assessment,
    system: {},
    checklist: {},
  });

  useEffect(() => {
    const searchChildren = (children, id) => {
      const childs = children || [];
      let found = childs.find((c) => getId(c) == id);

      if (found) {
        return found;
      } else {
        for (let i = 0; i < childs.length; i++) {
          found = searchChildren(childs[i].children, id);
          if (found) {
            break;
          }
        }
      }
      return found;
    };

    const findCurrentChecklist = (pSystem) => {
      if (activeEdit) {
        const pSystemIndex = treed.findIndex((t) => getId(t) === getId(pSystem));
        const checklists = get(pSystem, 'children', []);
        return {
          checklists,
          nextSystem: get(treed, pSystemIndex + 1),
          prevSystem: get(treed, pSystemIndex - 1),
          currentIndex: checklists.findIndex((f) => getId(f) === getId(get(activeEdit, 'checklist'))),
        };
      } else {
        return undefined;
      }
    };

    if (activeEdit) {
      const system = searchChildren(treed, getId(activeEdit.system));
      const pchecklist = searchChildren(treed, getId(activeEdit.checklist));

      const checklist = findCurrentChecklist(system);
      if (checklist && checklist.currentIndex !== -1) {
        const next = get(checklist.checklists, checklist.currentIndex + 1, { ...get(checklist.nextSystem, 'children.0'), _system: checklist.nextSystem });
        const prev = get(checklist.checklists, checklist.currentIndex - 1, { ...last(get(checklist.prevSystem, 'children', [])), _system: checklist.prevSystem });
        setDir({
          next,
          prev,
        });
      }
      setChildProps({
        isCourse,
        assessment,
        system,
        checklist: pchecklist,
      });
    }
  }, [treed, activeEdit]);

  const _props = {
    ...props,
    next: get(dir, 'next'),
    prev: get(dir, 'prev'),
    setSidebarOpen,
    setActiveEdit,
    activeEdit,
    setCurrentAnchor,
    updateScores,
    selectedItems,
    filter,
    scorecard,

    ...childProps,
  };

  const classes = useStyles();

  return (
    <div className={classes.activeEditContainer}>
      <SystemScore {..._props} />
    </div>
  );
};
